<template>
  <CRow>
    <CCol col="12" lg="12">
      <CCard>
        <CCardBody>
            <div class="row">
                <div class="col-6">
                    <CInput disabled :label="$t('fields.name')" type="text" v-model="role.name"/>
                </div>
            </div>
            <h3>{{ $t('roles.fields.permissions') }}</h3>
            <div class="row">
              <!-- clients -->
              <div class="col-3">
                <h4>{{ $tc('clients.label', 2) }}</h4>
                <CInputCheckbox
                  disabled
                  :label="$t('permissions.browse')"
                  value="true"
                  :checked="role.permissions.clients.browse"
                  @update:checked="selectCheckbox('browse', 'clients')"
                />
                <CInputCheckbox
                  disabled
                  :label="$t('permissions.view')"
                  value="true"
                  :checked="role.permissions.clients.read"
                  @update:checked="selectCheckbox('read', 'clients')"
                />
                <CInputCheckbox
                  disabled
                  :label="$t('permissions.add')"
                  value="true"
                  :checked="role.permissions.clients.add"
                  @update:checked="selectCheckbox('add', 'clients')"
                />
                <CInputCheckbox
                  disabled
                  :label="$t('permissions.edit')"
                  value="true"
                  :checked="role.permissions.clients.edit"
                  @update:checked="selectCheckbox('edit', 'clients')"
                />
                <CInputCheckbox
                  disabled
                  :label="$t('permissions.delete')"
                  value="true"
                  :checked="role.permissions.clients.delete"
                  @update:checked="selectCheckbox('delete', 'clients')"
                  class="mb-2"
                />
                <CInputCheckbox
                  disabled
                  :label="$t('permissions.browse_followup')"
                  value="true"
                  :checked="role.permissions.followup.browse"
                  @update:checked="selectCheckbox('browse', 'followup')"
                />
              </div>
              <!-- orders -->
              <div class="col-3">
                <h4>{{ $tc('orders.label', 2) }}</h4>
                <CInputCheckbox
                  disabled
                  :label="$t('permissions.browse')"
                  value="true"
                  :checked="role.permissions.orders.browse"
                  @update:checked="selectCheckbox('browse', 'orders')"
                />
                <CInputCheckbox
                  disabled
                  :label="$t('permissions.view')"
                  value="true"
                  :checked="role.permissions.orders.read"
                  @update:checked="selectCheckbox('read', 'orders')"
                />
                <CInputCheckbox
                  disabled
                  :label="$t('permissions.add')"
                  value="true"
                  :checked="role.permissions.orders.add"
                  @update:checked="selectCheckbox('add', 'orders')"
                />
                <CInputCheckbox
                  disabled
                  :label="$t('permissions.edit')"
                  value="true"
                  :checked="role.permissions.orders.edit"
                  @update:checked="selectCheckbox('edit', 'orders')"
                />
                <CInputCheckbox
                  disabled
                  :label="$t('permissions.delete')"
                  value="true"
                  :checked="role.permissions.orders.delete"
                  @update:checked="selectCheckbox('delete', 'orders')"
                  class="mb-2"
                />
              </div>
              <!-- employees -->
              <div class="col-3">
                <h4>{{ $tc('employees.label', 2) }}</h4>
                <CInputCheckbox
                  disabled
                  :label="$t('permissions.browse')"
                  value="true"
                  :checked="role.permissions.employees.browse"
                  @update:checked="selectCheckbox('browse', 'employees')"
                />
                <CInputCheckbox
                  disabled
                  :label="$t('permissions.view')"
                  value="true"
                  :checked="role.permissions.employees.read"
                  @update:checked="selectCheckbox('read', 'employees')"
                />
                <CInputCheckbox
                  disabled
                  :label="$t('permissions.add')"
                  value="true"
                  :checked="role.permissions.employees.add"
                  @update:checked="selectCheckbox('add', 'employees')"
                />
                <CInputCheckbox
                  disabled
                  :label="$t('permissions.edit')"
                  value="true"
                  :checked="role.permissions.employees.edit"
                  @update:checked="selectCheckbox('edit', 'employees')"
                />
                <CInputCheckbox
                  disabled
                  :label="$t('permissions.delete')"
                  value="true"
                  :checked="role.permissions.employees.delete"
                  @update:checked="selectCheckbox('delete', 'employees')"
                  class="mb-2"
                />
              </div>
              <!-- drivers -->
              <div class="col-3">
                <h4>{{ $tc('drivers.label', 2) }}</h4>
                <CInputCheckbox
                  disabled
                  :label="$t('permissions.browse')"
                  value="true"
                  :checked="role.permissions.drivers.browse"
                  @update:checked="selectCheckbox('browse', 'drivers')"
                />
                <CInputCheckbox
                  disabled
                  :label="$t('permissions.view')"
                  value="true"
                  :checked="role.permissions.drivers.read"
                  @update:checked="selectCheckbox('read', 'drivers')"
                />
                <CInputCheckbox
                  disabled
                  :label="$t('permissions.add')"
                  value="true"
                  :checked="role.permissions.drivers.add"
                  @update:checked="selectCheckbox('add', 'drivers')"
                />
                <CInputCheckbox
                  disabled
                  :label="$t('permissions.edit')"
                  value="true"
                  :checked="role.permissions.drivers.edit"
                  @update:checked="selectCheckbox('edit', 'drivers')"
                />
                <CInputCheckbox
                  disabled
                  :label="$t('permissions.delete')"
                  value="true"
                  :checked="role.permissions.drivers.delete"
                  @update:checked="selectCheckbox('delete', 'drivers')"
                  class="mb-2"
                />
              </div>
            </div>
            <div class="row">
              <!-- products -->
              <div class="col-3">
                <h3>{{ $tc('delivery_types.label', 2) }}</h3>
                <CInputCheckbox
                  disabled
                  :label="$t('permissions.browse')"
                  value="true"
                  :checked="role.permissions.delivery_types.browse"
                  @update:checked="selectCheckbox('browse', 'delivery_types')"
                />
                <CInputCheckbox
                  disabled
                  :label="$t('permissions.view')"
                  value="true"
                  :checked="role.permissions.delivery_types.read"
                  @update:checked="selectCheckbox('read', 'delivery_types')"
                />
                <CInputCheckbox
                  disabled
                  :label="$t('permissions.add')"
                  value="true"
                  :checked="role.permissions.delivery_types.add"
                  @update:checked="selectCheckbox('add', 'delivery_types')"
                />
                <CInputCheckbox
                  disabled
                  :label="$t('permissions.edit')"
                  value="true"
                  :checked="role.permissions.delivery_types.edit"
                  @update:checked="selectCheckbox('edit', 'delivery_types')"
                />
                <CInputCheckbox
                  disabled
                  :label="$t('permissions.delete')"
                  value="true"
                  :checked="role.permissions.delivery_types.delete"
                  @update:checked="selectCheckbox('delete', 'delivery_types')"
                  class="mb-2"
                />
                <CInputCheckbox
                  disabled
                  :label="$t('permissions.delivery_history')"
                  value="true"
                  :checked="role.permissions.delivery_history.browse"
                  @update:checked="selectCheckbox('browse', 'delivery_history')"
                />
              </div>
              <!-- report -->
              <div class="col-3">
                <h4>{{ $tc('reports.label', 2) }}</h4>
                <CInputCheckbox
                  disabled
                  :label="$t('permissions.browse')"
                  value="true"
                  :checked="role.permissions.reports.browse"
                  @update:checked="selectCheckbox('browse', 'reports')"
                />
                <CInputCheckbox
                  disabled
                  :label="$t('permissions.view')"
                  value="true"
                  :checked="role.permissions.reports.read"
                  @update:checked="selectCheckbox('read', 'reports')"
                />
                <CInputCheckbox
                  disabled
                  :label="$t('permissions.add')"
                  value="true"
                  :checked="role.permissions.reports.add"
                  @update:checked="selectCheckbox('add', 'reports')"
                />
                <CInputCheckbox
                  disabled
                  :label="$t('permissions.edit')"
                  value="true"
                  :checked="role.permissions.reports.edit"
                  @update:checked="selectCheckbox('edit', 'reports')"
                />
                <CInputCheckbox
                  disabled
                  :label="$t('permissions.delete')"
                  value="true"
                  :checked="role.permissions.reports.delete"
                  @update:checked="selectCheckbox('delete', 'reports')"
                  class="mb-2"
                />
              </div>
              <!-- expenses -->
              <div class="col-3">
                <h4>{{ $tc('expenses.label', 2) }}</h4>
                <CInputCheckbox
                  disabled
                  :label="$t('permissions.browse')"
                  value="true"
                  :checked="role.permissions.expenses.browse"
                  @update:checked="selectCheckbox('browse', 'expenses')"
                />
                <CInputCheckbox
                  disabled
                  :label="$t('permissions.view')"
                  value="true"
                  :checked="role.permissions.expenses.read"
                  @update:checked="selectCheckbox('read', 'expenses')"
                />
                <CInputCheckbox
                  disabled
                  :label="$t('permissions.add')"
                  value="true"
                  :checked="role.permissions.expenses.add"
                  @update:checked="selectCheckbox('add', 'expenses')"
                />
                <CInputCheckbox
                  disabled
                  :label="$t('permissions.edit')"
                  value="true"
                  :checked="role.permissions.expenses.edit"
                  @update:checked="selectCheckbox('edit', 'expenses')"
                />
                <CInputCheckbox
                  disabled
                  :label="$t('permissions.delete')"
                  value="true"
                  :checked="role.permissions.expenses.delete"
                  @update:checked="selectCheckbox('delete', 'expenses')"
                  class="mb-2"
                />
              </div>
              <!-- settings -->
              <div class="col-3">
                <h4>{{ $t('settings.label') }}</h4>
                <CInputCheckbox
                  disabled
                  :label="$t('permissions.browse')"
                  value="true"
                  :checked="role.permissions.settings.browse"
                  @update:checked="selectCheckbox('browse', 'settings')"
                />
                <CInputCheckbox
                  disabled
                  :label="$t('permissions.edit')"
                  value="true"
                  :checked="role.permissions.settings.edit"
                  @update:checked="selectCheckbox('edit', 'settings')"
                />
              </div>
            </div>
            <div class="row pt-4">
              <div class="col-4">
                <CButton color="success" @click="editRole">
                  <CIcon :content="$options.editIcon" /> {{ $t('button.edit') }}</CButton>
                <CButton color="primary" @click="goBack">
                  <CIcon :content="$options.backIcon" /> {{ $t('button.back') }}
                </CButton>
              </div>
            </div>
        </CCardBody>
      </CCard>
    </CCol>
  </CRow>
</template>

<script>
import axios from 'axios';
import formMixin from "../../mixins/form";
import localeMixin from '../../mixins/locale'; // Order matters, mixin first then i18n.
import i18n from "../../i18n";
import { cilPencil, cilArrowLeft } from '@coreui/icons';

export default {
  name: 'FormRole',
  mixins: [formMixin, localeMixin],
  editIcon: cilPencil,
  backIcon: cilArrowLeft,
  data() {
    return {
        role: {
          name: '',
          permissions: {
            clients: {},
            followup: {},
            orders: {},
            employees: {},
            delivery_types: {},
            delivery_history: {},
            reports: {},
            drivers: {},
            expenses: {},
            settings: {}
          },
          allPermissions: []
        },
        selectedPermissions: [],
    }
  },
  computed: {
    roleId() {
        return this.$route.params.id;
    }
  },
  mounted() {
    this.getRole();
  },
  methods: {
    goBack() {
      this.$router.push({ name: "Roles" });
    },
    editRole (id) {
      this.$router.push({ name: 'EditRole', params: {id: this.roleId} });
    },
    showAlert(type, msg) {
      let title = '';
      let body = '';
      let status = '';
      let redirect = true;

      switch(type) {
        case 'add':
          title = i18n.t('roles.modal.created_label');
          body = i18n.t('roles.modal.created_body');
          status = 'success';
          break;
        case 'edit':
          title = i18n.t('roles.modal.updated_label');
          body = i18n.t('roles.modal.updated_body');
          status = 'success';
          break;
        case 'error':
          title = 'Error';
          body = msg;
          status = 'danger';
          redirect = false;
          break;
      }

      this.$swal(
        title,
        body,
        status
      ).then(result => {
        if (redirect) {
          this.goBack();
        }
      });
    },
    getRole() {
        const token = this.token === null ? localStorage.getItem("api_token") : this.token;
        const url = `/api/roles/${this.roleId}/edit?token=${token}`;
        axios.get(url)
        .then(response => {
            this.role = response.data;
            this.selectedPermissions = response.data.allPermissions;
        }).catch(error => {
            console.log(error);
            this.$router.push({ path: '/login' });
        });
    }
  }
}

</script>
